import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const CraneGuard = ({ children, ...rest }) => {
  const token = localStorage.getItem("token:data");

  const { profile } = useSelector((state) => state.users);

  let isCraneAdminGuard = profile
    ? (profile.role && 
        ((profile.role.map((role) => role.name).includes("admin")) || (profile.role.map((role) => role.name).includes("crane_admin")))
      )
    : false;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        token && isCraneAdminGuard ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: {
                from: location,
              },
            }}
          />
        )
      }
    />
  );
};

export default CraneGuard;
